var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-list"},[_vm._m(0),_c('p',{staticClass:"no-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{staticClass:"no",attrs:{"src":require("../assets/images/no.png"),"alt":""}})])
}]

export { render, staticRenderFns }